import {useEffect, useRef, useState} from "react";
import axios from 'axios';
import { setError } from "../../../slices/error/ErrorSlice";
import { useDispatch } from "react-redux";
import Modal from "../../elements/Modal";
import {isJsonString} from "../../../functions/functions";
import {formValid, resetFieldsErrors} from "../../../functions/form";
import Select from "../../elements/Select";

export default function Markings() {
    const dispatch = useDispatch();

    const[colors, setColors] = useState([]);
    const[list, setList] = useState([]);

    const[form, setForm] = useState({
        name: '',
        color: 1
    })
    const formRefs = useRef({
        name: useRef(null),
        // color: useRef(null)
    });
    const[modalShow, setModalShow] = useState(false);
    const[modalDelShow, setModalDelShow] = useState(false);
    const[editId, setEditId] = useState(null);
    const[delId, setDelId] = useState(null);
    const[nameDel, setNameDel] = useState(null);

    useEffect(() => {
        getList();

        axios.get('/api/colors')
            .then(res => {
                setColors(res.data)
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }, []);

    function modalShowToggler() {
        setModalShow(!modalShow);
    }

    function closeModalEntity() {
        setModalShow(!modalShow);
        resetForm();
        resetFieldsErrors(formRefs.current);
        setEditId(null);
    }

    function resetForm() {
        setForm({
            name: '',
            color: 1
        })
    }

    function openModalDelHandler(e) {
        setDelId(Number(e.currentTarget.getAttribute('iid')));
        setNameDel(e.currentTarget.previousSibling.previousSibling.previousSibling.innerHTML)
        setModalDelShow(!modalDelShow);
    }

    function closeModalDelHandler() {
        setModalDelShow(!modalDelShow);
        setDelId(null);
        setNameDel(null);
    }

    function getItemHandler(e) {
        const id = e.currentTarget.getAttribute('iid');
        setEditId(id);

        axios.get(`/api/markings/${id}`)
            .then(res => {
                setForm(Object.assign(form, res.data));
                modalShowToggler();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function getList() {
        axios.get('/api/markings-list')
            .then(res => {
                setList(res.data);
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function changeHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        if (fieldName === 'color') value = Number(value);

        setForm({...form, [fieldName]: value});
    }

    function createHandler() {
        axios.post('/api/markings/create', form)
            .then(res => {
                getList();
                closeModalEntity();
            })
            .catch((e) => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function editHandler() {
        axios.post(`/api/markings/${editId}/edit`, form)
            .then(res => {
                closeModalEntity();
                getList();
            })
            .catch(e => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function delHandler() {
        axios.delete(`/api/markings/${delId}/del`)
            .then(res => {
                closeModalDelHandler();
                getList();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    let rows = list.map(item =>
        <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.name}</td>
            <td>{item.color}</td>
            <td iid={item.id} onClick={getItemHandler}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-pencil hover" viewBox="0 0 16 16">
                    <path
                        d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
            </td>
            <td iid={item.id} onClick={openModalDelHandler}>
                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
            </td>
        </tr>
    )

    return(
        <>
            <Modal
                header = { editId ? 'Редактирование' : 'Добавить пометку' }
                show={modalShow}
                closeHandler={closeModalEntity}
            >
                <div className="mb-3 row">
                    <label htmlFor="inputLogin" className="col-sm-3 col-form-label">Наименование</label>
                    <div className="col-sm-9">
                        <input type="text" name='name' className="form-control" id="name" ref={formRefs.current.name}
                               onChange={changeHandler} value={form.name}
                        />
                    </div>
                </div>
                <div className="my-3 row">
                    <label htmlFor="color-select" className="col-sm-3 col-form-label">Цвет</label>
                    <div className="col-sm-9">
                        <Select data={colors} name='color' id="color-select" value={form.color} handler={changeHandler}/>
                    </div>
                </div>

                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={ editId ? editHandler : createHandler}
                           value="Сохранить"/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalEntity}
                           value='Отмена'/>
                </div>
            </Modal>

            <Modal
                header='Удалить пометку'
                show={modalDelShow}
                closeHandler={closeModalDelHandler}
            >
                <div className="float-none">{nameDel}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={delHandler}
                           value='Да'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalDelHandler}
                           value='Нет'/>
                </div>
            </Modal>

            <h1>Пометки</h1>

            <input type='button' className='btn btn-primary margin-botom' onClick={modalShowToggler} value='Добавить'/>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col" style={{width: 95}}>ID</th>
                    <th scope="col">Пометка</th>
                    <th scope="col">Цвет</th>
                    <th scope="col" style={{width: 95}}></th>
                    <th scope="col" style={{width: 95}}></th>
                </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        </>
    )
}